
import request from '@/utils/request'
/**
 * 获取当前登录人名下注册登记的球杆
 * @param
 * @returns {*}
 */
export function memberInformation() {
    return request({
        url: '/userClient/salesMy/memberInformation',
        method: 'get',
    })
}

export function memberAvatar(formData) {
    return request({
        url: '/userClient/salesMy/memberAvatar',
        method: 'post',
        data: formData
    })
}

export function updateMemberInfo(formData) {
    return request({
        url: '/userClient/salesMy/updateMember',
        method: 'post',
        data: formData
    })
}

export function memberEquities() {
    return request({
        url: '/userClient/salesMy/memberEquities',
        method: 'get',
    })
}

export function seriesOfCueSticks(seriesId) {
    return request({
        url: '/userClient/salesMy/seriesOfCueSticks',
        method: 'get',
        params: {seriesId}
    })
}

export function memberEquitiesUse( equitiesId,  seriesId,  number) {
    return request({
        url: '/userClient/salesMy/memberEquitiesUse',
        method: 'get',
        params: {equitiesId: equitiesId, seriesId: seriesId, number: number}
    })
}

export function memberEquitiesUseCheck( benefits,  number) {
    return request({
        url: '/userClient/salesMy/memberEquitiesUseCheck',
        method: 'get',
        params: {benefits: benefits, number: number}
    })
}

export function useBenefitsStoreProvCity() {
    return request({
        url: '/userClient/salesMy/useBenefitsStore',
        method: 'get',
    })
}

export function useBenefitsStoreById(storeId) {
    return request({
        url: '/userClient/salesMy/useBenefitsStoreById',
        method: 'get',
        params: {storeId}
    })
}

export function logout() {
    return request({
        url: '/userClient/salesMy/logout',
        method: 'get',
    })
}

export function shippingAddress() {
    return request({
        url: '/userClient/salesMy/shippingAddress',
        method: 'get',
    })
}